export const RES_SUMMARY_CONSTANTS = {
    SHIP_CODE_ERROR: 'NOT_XP',
    MY_RES_URL: {
        getUrl: (reservationId?) => {
            reservationId = reservationId ? `${reservationId}/` : '';
    
            return `/my-disney-cruise/my-reservations/${reservationId}`;
        }
    }
};
